import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ElementDirective, SvgDirective } from '@shared/directives';
import { SelectionButtonFirstVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  selector: 'b2c-variant1',
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [
    SafePipe,
    RewardPipe,
    SvgDirective,
    ButtonComponent,
    VariableReplacementPipe,
  ],
})
export class Variant1Component extends SelectionButtonBaseClass {
  config = input.required<SelectionButtonFirstVariantConfig>();
}
